.purchase_global {
	margin-right: 20px !important;
	margin-left: 20px !important;
	margin-top: 5px;
	padding-bottom: 1em;

	.purchase_content {
		min-height: 82vh;
		max-height: 82vh;
		display: flex;
		flex-direction: column;
		width: 100%;
		box-shadow: 5px 5px 10px #dfe1e6;
		background-color: white;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
		margin-bottom: 5px;

		@media (max-width: 820px) {
			min-height: 77vh;
			max-height: 77vh;
		}

		@media (max-width: 400px) {
			min-height: 73vh;
			max-height: 73vh;
			box-shadow: none;
		}

		.actions {
			height: 10%;

			.actionRow {
				display: flex;
				align-items: center;

				.label {
					display: inline-flex;
					width: 7%;
					font-size: 13px;
				}

				.optionButton {
					display: inline-flex;
					background-color: #fafafa;
					padding: 7px 10px;
					border-radius: 10px;
					font-size: 13px;
					font-weight: 400;
					margin-right: 10px;
					cursor: pointer;
					max-width: 15em;

					span {
						margin-left: 30px;
						div {
							display: inline-flex;
							font-weight: 700;
						}
					}

					&:hover {
						background-color: #7fb02f;
						color: white;
					}

					.icon {
						margin-right: 7px;
						margin-top: 3px;
					}

					&.copyElement {
						background-image: url("../../assets/images/desktop/copy.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;

						&:hover {
							background-image: url("../../assets/images/desktop/copyWhite.svg");
						}

						&.active {
							background-image: url("../../assets/images/desktop/copyWhite.svg");
							color: white;
							background-color: #7fb02f;
						}
					}

					&.copyCalculate {
						background-image: url("../../assets/images/desktop/calculate.svg");
						background-position: left;
						background-repeat: no-repeat;
						background-size: 40px 20px;

						&:hover {
							background-image: url("../../assets/images/desktop/calculateWhite.svg");
						}

						&.active {
							background-image: url("../../assets/images/desktop/calculateWhite.svg");
							color: white;
							background-color: #7fb02f;
						}
					}
				}
			}

			.separator {
				width: 98%;
				margin-top: 1px;
				margin-bottom: 5px;
			}
		}

		.selectUnit {
			display: inline-flex;
			background-color: #fafafa;
			padding: 0.6em;
			border-radius: 10px;
			font-size: 14px;
			font-weight: 500;
			margin-right: 10px;
			cursor: pointer;
			border: none;
			width: 100%;
		}
	}

	@media (max-width: 820px) {
		margin-right: 10px !important;
		margin-left: 10px !important;
	}
}

.detail_div_table {
	width: 100%;
	padding-left: 1em;
	padding-right: 1em;

	.detail_table {
		width: 100%;
		font-size: 15px;
		text-align: center;
		margin-bottom: 6px;

		.detail_th {
			border: none;
			padding: 5px;
			background-color: #f1f1f1;
			border-bottom: 1px solid black;
			color: black;
			font-weight: 500;
			font-size: 12px;
		}
	}
}
